import { render, staticRenderFns } from "./Chat.html?vue&type=template&id=0b461432&scoped=true&external"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.scss?vue&type=style&index=0&id=0b461432&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b461432",
  null
  
)

export default component.exports